module.exports = `${require.publicPath}icon04.b27b2309.png`;